document.addEventListener('DOMContentLoaded', () => {
  class MediaCoverageGrid {
    constructor(container) {
      this.container = container;
      this.activePanel = null;
      this.activeCardIndex = null;
      this.bindEvents();
    }

    bindEvents() {
      // Event delegation for clicks inside the grid container
      this.container.addEventListener('click', (e) => {
        const viewAllBtn = e.target.closest('.js-view-all');
        const closeBtn = e.target.closest('.js-close-panel');

        if (viewAllBtn) {
          const card = viewAllBtn.closest('[data-card]');
          this.togglePanel(card);
        }

        if (closeBtn) {
          this.closePanel();
        }
      });

      // Close on resize (prevents awkward layout breaks when columns change)
      window.addEventListener('resize', () => {
        if (this.activePanel) this.closePanel();
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.activePanel) {
          this.closePanel();
        }
      });
    }

    togglePanel(card) {
      const index = card.dataset.index;

      // If clicking the same card's button, close it
      if (this.activeCardIndex === index) {
        this.closePanel();
        return;
      }

      this.closePanel(); // Close any currently open panel

      // --- Dynamic Row Detection ---
      // We calculate which cards belong to the same row by checking their Y position (top bounds).
      // This works natively with CSS Grid wraps regardless of screen size.
      const allCards = Array.from(this.container.querySelectorAll('[data-card]'));
      const cardRect = card.getBoundingClientRect();
      let insertAfterElement = card;

      for (let i = allCards.indexOf(card) + 1; i < allCards.length; i++) {
        const nextCardRect = allCards[i].getBoundingClientRect();
        // Allow a 10px sub-pixel rendering tolerance
        if (Math.abs(nextCardRect.top - cardRect.top) < 10) {
          insertAfterElement = allCards[i];
        } else {
          // As soon as the Y position changes, we've hit the next row
          break; 
        }
      }

      // --- Build & Inject Panel ---
      this.activePanel = document.createElement('div');
      this.activePanel.className = 'media-coverage-panel';
      
      // Extract the pre-rendered server-side HTML from the clicked card
      const panelData = card.querySelector('.media-coverage-panel-data');
      this.activePanel.innerHTML = panelData.innerHTML;

      // Insert the panel into the CSS Grid directly after the last card of the current row
      insertAfterElement.parentNode.insertBefore(this.activePanel, insertAfterElement.nextSibling);

      // --- Update ARIA & State ---
      this.activeCardIndex = index;
      card.querySelector('.js-view-all').setAttribute('aria-expanded', 'true');
      
      // Optional: Smooth scroll slightly to ensure the panel is in view
      this.activePanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    closePanel() {
      if (this.activePanel) {
        this.activePanel.remove();
        this.activePanel = null;
      }
      
      if (this.activeCardIndex !== null) {
        const activeBtn = this.container.querySelector(`[data-index="${this.activeCardIndex}"] .js-view-all`);
        if (activeBtn) activeBtn.setAttribute('aria-expanded', 'false');
        this.activeCardIndex = null;
      }
    }
  }

  // Initialize on all media coverage grids on the page
  const grids = document.querySelectorAll('.media-coverage-grid');
  grids.forEach(grid => new MediaCoverageGrid(grid));
});